
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-535f6284!postcss!sass!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Root.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./Root.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-535f6284!../node_modules/vue-loader/lib/selector?type=template&index=0!./Root.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/Root.vue
// module id = 314
// module chunks = 0